/* npm imports */
import Vue from "vue";
import VueMaterial from "vue-material";
//import VCalendar from "v-calendar";

import App from "./App.vue";
import store from "./store";
import router from "./router";

import "./filters";
import "./init/firebase.init";

import "./registerServiceWorker";

import vuedatefns from "@/plugins/datefns";

import "@/assets/styles/styling.scss";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
Vue.use(VueMaterial);
Vue.use(vuedatefns);

if (process.env.NODE_ENV === "production") {
  Vue.config.productionTip = true;
  //window.console.log = function log() {};
} else {
  Vue.config.productionTip = false;
}

new Vue({
  render: h => h(App),
  store,
  router
}).$mount("#app");
